<template>
    <!-- <Select  v-model="selectModel" style="width:100px;">
        <Option v-for="(item, index) in selectOptions" :value="index + 1" :key="item.value">{{ item.label }}</Option>
    </Select> -->
  <RadioGroup  v-model="selectModel" >
    <Radio v-for="(item, index) in selectOptions" :label="index + 1"  :key="item.value">{{ item.label }}</Radio>
  </RadioGroup>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      selectOptions: [
        {
          value: 60,
          label: "五中一 "
        },
        {
          value: 61,
          label: "六中一 "
        },
        {
          value: 62,
          label: "七中一 "
        },
        {
          value: 63,
          label: "八中一 "
        },
        {
          value: 64,
          label: "九中一 "
        },
        {
          value: 65,
          label: "十中一 "
        }
      ],
    };
  },
  computed: {
      ...mapGetters(['getliveshow']),
    selectModel: {
      get() {
        return this.getliveshow.proj;
      },
      set(val) {
        const value = this.selectOptions[val - 1]
        this.chg_liveshow_state({ title: value.label, donotcode: value.value, proj: val });
        this.upDate_reload()
      }
    },
  },
  created () {
    this.changeState()
  },
  methods: {
      ...mapActions(["chg_liveshow_state", 'upDate_reload']),
    changeState () {
      const value = this.selectOptions[0]
      this.chg_liveshow_state({ title: value.label, donotcode: value.value, proj: 1 });
      this.upDate_reload()
    }
  }
};
</script>